import { Controller } from "@hotwired/stimulus"

// Builder Money (company view): ledger confirm/dismiss, follow-ups, retainage
// release requests, bank balance entry, concierge request.
export default class extends Controller {
  static targets = ["conciergeModal", "conciergeNotes", "bankModal", "bankAmount", "bankDate"]

  connect() {
    const msg = sessionStorage.getItem("builder-finance.flash")
    if (msg) {
      sessionStorage.removeItem("builder-finance.flash")
      this._showToast(msg)
    }
  }

  openJob(e) {
    if (e.target.closest("button, a")) return
    window.location.href = e.currentTarget.dataset.url
  }

  openConciergeModal() { this.conciergeModalTarget.classList.remove("hidden") }
  openBankModal() { this.bankModalTarget.classList.remove("hidden") }
  closeModals() {
    if (this.hasConciergeModalTarget) this.conciergeModalTarget.classList.add("hidden")
    if (this.hasBankModalTarget) this.bankModalTarget.classList.add("hidden")
  }
  stopPropagation(e) { e.stopPropagation() }

  async confirmFound(e) {
    const row = e.currentTarget.closest("tr")
    const resp = await fetch(e.currentTarget.dataset.url, { method: "POST", headers: this._headers() })
    if (resp.ok) {
      const pill = row.querySelector("td:nth-child(5)")
      if (pill) pill.innerHTML = '<span class="inline-flex items-center px-2 py-0.5 rounded-full text-[13px] font-medium bg-green-100 text-green-700">Confirmed</span>'
      row.querySelector("td:last-child").innerHTML = ""
      this._showToast("Counted — it's on your Worth Meter now")
    }
  }

  async dismissFound(e) {
    const row = e.currentTarget.closest("tr")
    const resp = await fetch(e.currentTarget.dataset.url, { method: "POST", headers: this._headers() })
    if (resp.ok) row.remove()
  }

  async sendFollowup(e) {
    const btn = e.currentTarget
    btn.disabled = true
    try {
      const resp = await fetch(btn.dataset.url, { method: "POST", headers: this._headers() })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || "Could not send")
      this._showToast(`Sent (${data.kind}) — from your name, reply-to you`)
    } catch (err) {
      this._showToast(err.message, "alert")
    } finally {
      btn.disabled = false
    }
  }

  async requestRelease(e) {
    const btn = e.currentTarget
    btn.disabled = true
    try {
      const resp = await fetch(btn.dataset.url, { method: "POST", headers: this._headers() })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || "Could not send the request")
      this._showToast("Release request emailed to the owner")
    } catch (err) {
      this._showToast(err.message, "alert")
    } finally {
      btn.disabled = false
    }
  }

  async saveBank(e) {
    try {
      const resp = await fetch(e.currentTarget.dataset.url, {
        method: "POST", headers: this._headers(),
        body: JSON.stringify({ balance: this.bankAmountTarget.value, as_of: this.bankDateTarget.value })
      })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || "Could not save")
      sessionStorage.setItem("builder-finance.flash", "Bank balance updated")
      window.location.reload()
    } catch (err) {
      this._showToast(err.message, "alert")
    }
  }

  async requestConcierge(e) {
    try {
      const resp = await fetch(e.currentTarget.dataset.url, {
        method: "POST", headers: this._headers(),
        body: JSON.stringify({ notes: this.conciergeNotesTarget.value })
      })
      if (!resp.ok) throw new Error("Could not send the request")
      this.closeModals()
      this._showToast("Got it — the ConsLog team will reach out to set things up with you")
    } catch (err) {
      this._showToast(err.message, "alert")
    }
  }

  _headers() {
    return {
      "Content-Type": "application/json", "Accept": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
    }
  }

  _showToast(message, type = "notice") {
    const div = document.createElement("div")
    div.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    div.setAttribute("data-controller", "flash")
    div.setAttribute("data-flash-dismiss-after-value", "5000")
    div.textContent = message
    document.body.prepend(div)
  }
}
